import axioInstance from "../../custom_utilities/AxiosInstance/axiosInstance";

const BASE_ANALYTICS_URL =
  "https://learning.motion.ac.in/motioneducation/api/v1/getAnalyticsReport";
const PRACTICE_SOLUTION_URL =
  "https://learning.motion.ac.in/motioneducation/api/v1/practise_solution";
const TOPIC_WISE_URL =
  "https://learning.motion.ac.in/motioneducation/api/v1/topicWiseComparison";
const SUBJECT_WISE_URL =
  "https://learning.motion.ac.in/motioneducation/api/v1/subjectWiseAnalysis";
const OVERALL_ANALYTICS_URL =
  "https://learning.motion.ac.in/motioneducation/api/v1/getoverallAnalyticsReport";
const QUESTION_ANALYSIS =
  "https://learning.motion.ac.in/motioneducation/api/v1/questionAnalysis";

const buildQueryParams = (params) =>
  Object.entries(params)
    .filter(
      ([, v]) => v !== undefined && v !== null && `${v}`.trim() !== ""
    )
    .map(
      ([k, v]) =>
        `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`
    )
    .join("&");

/* ================= URL BUILDER ================= */
const buildUrl = ({
  baseUrl,
  paperId,
  paperType,
  setId,
  attemptCount,
  plannerTestId,
  isOffline,
  filter_by,
  selectedAttemptId,
  selected_attempt,
}) => 
//   {
//   let url = `${baseUrl}?paper_type=${paperType}&paper_id=${paperId}`;

//   if (filter_by) url += `&filter_by=${filter_by}`;

//   if (paperType !== 3) {
//     url += `&set_id=${setId}`;
//   }
// if (selectedAttemptId !== undefined) {
//   url += `&selected_attempt=${selectedAttemptId}`;
// }
// if (paperType === 3 && attemptCount !== undefined) {
//   url += `&attempt_count=${attemptCount}`;
// }
//   if (paperType === 3 && plannerTestId) {
//     url += `&planner_test_id=${plannerTestId}`;
//   }

//   if (paperType === 3 && isOffline !== undefined) {
//     url += `&isOffline=${isOffline}`;
//   }
{
  let url = `${baseUrl}?paper_type=${paperType}`;
  const attemptValue =
    attemptCount !== undefined
      ? attemptCount
      : selected_attempt !== undefined
      ? Number(selected_attempt) + 1
      : selectedAttemptId !== undefined
      ? Number(selectedAttemptId) + 1
      : undefined;

  // ✅ Only attach paper_id if exists
  if (paperId) {
    url += `&paper_id=${paperId}`;
  }

  // ✅ Only attach set_id if exists
  if (setId) {
    url += `&set_id=${setId}`;
  }

  if (filter_by) {
    url += `&filter_by=${filter_by}`;
  }

  if (attemptValue !== undefined) {
    url += `&attempt_count=${attemptValue}`;
  }

  if (paperType === 3 && plannerTestId) {
    url += `&planner_test_id=${plannerTestId}`;
  }

  if (paperType === 3 && isOffline !== undefined) {
    url += `&isOffline=${isOffline}`;
  }
  return url;
};

const analyticsApi = {
  getBasicAnalytics: async (payload) => {
    const res = await axioInstance.get(
      buildUrl({ ...payload, baseUrl: BASE_ANALYTICS_URL })
    );
    return res.data;
  },

  getPracticeSolution: async (payload) => {
    const res = await axioInstance.get(
      buildUrl({ ...payload, baseUrl: PRACTICE_SOLUTION_URL })
    );
    return res.data;
  },

  getTopicWiseComparison: async (payload) => {
    const res = await axioInstance.get(
      buildUrl({ ...payload, baseUrl: TOPIC_WISE_URL })
    );
    return res.data;
  },

  getSubjectWiseComparison: async (payload) => {
    const res = await axioInstance.get(
      buildUrl({ ...payload, baseUrl: SUBJECT_WISE_URL })
    );
    return res.data;
  },

  getOverallAnalytics: async (payload) => {
    const res = await axioInstance.get(
      buildUrl({ ...payload, baseUrl: OVERALL_ANALYTICS_URL })
    );
    return res.data;
  },

  getQuestionAnalytics: async ({
    paperId,
    paperType,
    setId,
    qid,
    isOffline = 0,
    attemptCount,
  }) => {
    const queryParams = {
      paper_id: paperId,
      paper_type: paperType,
      qid,
      set_id: setId,
      is_offline: isOffline ?? 0,
      attempt_count: attemptCount,
    };
    const qs = buildQueryParams(queryParams);
    const res = await axioInstance.get(`${QUESTION_ANALYSIS}?${qs}`);
    return res.data;
  },
};

export default analyticsApi;
